import { useContext } from 'react'

import { StringsContext } from '@lib/strings-context'
import { getLinkPageUrl } from '@lib/routes'
import { UserContext } from '@lib/user/context'

import ButtonLink, {
  ButtonColor,
  ButtonIconAlignment,
  ButtonSize,
  ButtonVariant,
} from '@components/buttons/button-link'
import { ButtonProps } from '@components/buttons/button'

type SharedButtonProps = Pick<
  ButtonProps,
  'variant' | 'size' | 'color' | 'hideLabelUntil' | 'icon'
>

const AccountButton = () => {
  const strings = useContext(StringsContext)
  const { user } = useContext(UserContext)

  const sharedButtonProps: SharedButtonProps = {
    variant: ButtonVariant.OUTLINED,
    size: ButtonSize.SMALL,
    color: ButtonColor.GRAY,
    hideLabelUntil: 'md',
    icon: 'User',
  }

  if (!user) {
    return <ButtonLink href="/" {...sharedButtonProps} />
  }

  const loginPageUrl = getLinkPageUrl({
    pageType: 'loginPage',
  })
  const accountPageUrl = getLinkPageUrl({
    pageType: 'accountPage',
  })

  if (!user.isLoggedIn) {
    return (
      <ButtonLink
        {...sharedButtonProps}
        href={loginPageUrl}
        iconAlignment={ButtonIconAlignment.RIGHT}
      >
        {strings.buttonLogin}
      </ButtonLink>
    )
  }

  return (
    <ButtonLink
      {...sharedButtonProps}
      href={accountPageUrl}
      iconAlignment={ButtonIconAlignment.LEFT}
    >
      {user.customer
        ? `${user.customer?.firstName.charAt(0)}. ${user.customer?.lastName}`
        : ''}
    </ButtonLink>
  )
}

export default AccountButton
